"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const Tooltip = (props) => {
    const [relativePosition, setPosition] = react_1.useState(props.position);
    const [windowWidth, setWidth] = react_1.useState(window.innerWidth);
    const [prevWindowWidth, setPrevWindowWidth] = react_1.useState(window.innerWidth);
    react_1.useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    react_1.useEffect(() => {
        const tooltip = document.getElementById('tooltip');
        if (tooltip) {
            const rect = tooltip.getBoundingClientRect();
            const left = rect.left;
            const right = rect.right;
            if (props.position === 'left') {
                if (left < 0) {
                    setPosition('right');
                    setPrevWindowWidth(windowWidth);
                }
                else if (prevWindowWidth > windowWidth && relativePosition === 'right') {
                    return;
                }
                else {
                    setPosition('left');
                    setPrevWindowWidth(windowWidth);
                }
            }
            else {
                if (windowWidth - right < 0) {
                    setPosition('left');
                    setPrevWindowWidth(windowWidth);
                }
                else if (prevWindowWidth > windowWidth && relativePosition === 'left') {
                    return;
                }
                else {
                    setPosition('right');
                    setPrevWindowWidth(windowWidth);
                }
            }
        }
    }, [windowWidth]);
    const tooltipPosition = classnames_1.default({
        'tooltip': true,
        'tooltip-box': true,
        [`tooltip-bottom-${relativePosition}`]: true,
    });
    return (React.createElement("div", { className: tooltipPosition },
        React.createElement("div", { className: 'tooltip-inner' },
            React.createElement("button", { type: "button", className: "close", "aria-label": "Close", "aria-hidden": "true", onClick: props.handleClose }, "\u00D7"),
            React.createElement("div", { className: "tooltip-text" }, props.text))));
};
exports.Tooltip = Tooltip;
//# sourceMappingURL=Tooltip.js.map